import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { PlasticsDeclarationReviewData } from '../../../../../../types/products'
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet'
import { Router } from '@angular/router'
import { TranslationService } from '../../../../../../services/translation.service'

import { MatListModule } from '@angular/material/list'
import { MatIconModule } from '@angular/material/icon'
import {
  PRODUCT_MATERIAL_TYPE_PLASTIC_PRODUCT,
  PRODUCT_MATERIAL_TYPE_RAW_RESIN,
  PRODUCT_MATERIAL_TYPE_NON_PLASTIC,
  PRODUCT_MATERIAL_TYPE_UNDECLARED,
} from '../../../../../../constants/plastics-declaration'

@Component({
  selector: 'app-plastics-declaration-sheet',
  imports: [MatListModule, MatIconModule],
  templateUrl: './plastics-declaration-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './plastics-declaration-sheet.component.scss',
})
export class PlasticsDeclarationSheetComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA)
  router = inject(Router)
  translationService = inject(TranslationService)

  plasticsDeclaration: PlasticsDeclarationReviewData | undefined

  // Map backend material type enums to human-readable labels
  readonly MATERIAL_TYPE_LABELS: Record<string, string> = {
    RawResin: 'Raw Resin',
    PlasticProduct: 'Plastic Product',
    NonPlastic: 'Non-Plastic',
    Undeclared: 'Composition not declared',
  }

  // Returns a user-friendly label for the given material type
  displayMaterialType(mt?: string | null): string {
    if (!mt) return ''
    return this.MATERIAL_TYPE_LABELS[mt] ?? mt
  }

  // Formats selected waste streams as comma-separated list
  formatWasteStreams(declaration: PlasticsDeclarationReviewData): string {
    const selectedStreams: string[] = []

    if (declaration.isResidentialWasteStream) {
      selectedStreams.push(this.translationService.getResidentialText())
    }
    if (declaration.isIciWasteStream) {
      selectedStreams.push(this.translationService.getIciText())
    }
    if (declaration.isCdrWasteStream) {
      selectedStreams.push(this.translationService.getCdrText())
    }

    return selectedStreams.length > 0
      ? selectedStreams.join(', ')
      : this.translationService.getNaText()
  }

  // True when the current declaration is a Plastic Product.
  isPlasticProduct(): boolean {
    const t = this.plasticsDeclaration?.productMaterialType
    return t === PRODUCT_MATERIAL_TYPE_PLASTIC_PRODUCT
  }

  // True when the current declaration is a Raw Resin.
  isRawResin(): boolean {
    const t = this.plasticsDeclaration?.productMaterialType
    return t === PRODUCT_MATERIAL_TYPE_RAW_RESIN
  }

  // Neither type has plastics reporting fields.
  isNonPlastic(): boolean {
    const t = this.plasticsDeclaration?.productMaterialType
    return (
      t === PRODUCT_MATERIAL_TYPE_NON_PLASTIC ||
      t === PRODUCT_MATERIAL_TYPE_UNDECLARED
    )
  }

  // the object injected below has to be any since 'data' is dynamic

  constructor() {
    const data = this.data

    console.log(data)
    if (data.plasticsDeclaration) {
      this.plasticsDeclaration = data.plasticsDeclaration
    }
  }

  /**
   * Handles the `keydown` event for keyboard navigation.
   * Allows navigating the list using arrow keys and selecting items with Enter.
   *
   * @param {KeyboardEvent} event - The keyboard event triggered when a key is pressed down.
   * @param {number} index - The current index of the focused list item.
   */
  onKeydown(event: KeyboardEvent, index: number): void {
    // Prevent default scroll behavior
    event.preventDefault()
    const listItems = document.querySelectorAll('a[mat-list-item]')

    if (event.key === 'ArrowDown') {
      // Focus the next item, if it exists
      if (index < listItems.length - 1)
        (listItems[index + 1] as HTMLElement).focus()
    } else if (event.key === 'ArrowUp') {
      // If the current index is greater than 0, focus on the previous item
      if (index > 0) (listItems[index - 1] as HTMLElement).focus()
    }
  }
}
